import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'
import * as ToastPrimitive from '@radix-ui/react-toast'

interface Toast { id: number; message: string; tone: 'info' | 'error' }
interface ToastContextValue { toast: (message: string, tone?: Toast['tone']) => void }
const ToastContext = createContext<ToastContextValue | null>(null)

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<Toast[]>([])
  const toast = useCallback((message?: string, tone: Toast['tone'] = 'info') => {
    if (!message) return
    const id = Date.now() + Math.random()
    setItems((current) => [...current, { id, message, tone }])
    if (tone === 'info') window.setTimeout(() => setItems((current) => current.filter((item) => item.id !== id)), 6_000)
  }, [])
  const value = { toast }
  return <ToastContext.Provider value={value}><ToastPrimitive.Provider swipeDirection="right">{children}{items.map((item) => <ToastPrimitive.Root key={item.id} className={item.tone === 'error' ? 'toast toast-error' : 'toast'} role={item.tone === 'error' ? 'alert' : 'status'} open onOpenChange={(open) => { if (!open) setItems((current) => current.filter((candidate) => candidate.id !== item.id)) }} duration={item.tone === 'error' ? Infinity : 6_000}><ToastPrimitive.Description>{item.message}</ToastPrimitive.Description><ToastPrimitive.Close aria-label="Dismiss notification">×</ToastPrimitive.Close></ToastPrimitive.Root>)}<ToastPrimitive.Viewport className="toast-viewport" /></ToastPrimitive.Provider></ToastContext.Provider>
}

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext)
  return context ?? { toast: () => undefined }
}
